import {
  formatBytes,
  formatDateWithDayAndHour,
  formatHourAndMinute,
  formatNumber,
  formatTimeWithWeekDay,
  xAxisDailyDateFormatter,
} from '~/components/echarts/formatters'

function emptyData(data) {
  return Object.keys(data.data)?.length === 0
}

function formatValueWithUnit(value, unit) {
  if (unit === 'Bytes') {
    return formatBytes(value)
  }
  return `${formatNumber(value)} ${unit}`
}

const dataZoom = [
  {
    type: 'slider',
    labelFormatter: (_index, isodateStr) => formatDateWithDayAndHour(isodateStr),
  },
]

export function largeScaleStackedAreaChart(rawData) {
  const { data, unit, x, max_y_axis_value: maxYAxisValue, limit_line: limitLine, limit_lines: limitLines } = rawData

  const dateFormat = x.format

  const series = Object.entries(data).map(([name, values]) => {
    return {
      name,
      stack: 'x',
      type: 'line',
      // emphasis: { focus: 'series' },
      areaStyle: {},
      data: values,
    }
  })

  const limitLinesData = Array.isArray(limitLines) && limitLines.length > 0 ? [...limitLines] : []
  if (limitLinesData.length === 0 && limitLine) {
    limitLinesData.push(limitLine)
  }

  if (limitLinesData.length > 0) {
    limitLinesData
      .slice()
      .reverse()
      .forEach(({ name, value, color }) => {
        const lineColor = color || '#EE6666'
        series.unshift({
          name,
          type: 'line',
          data: new Array(x.values.length).fill(value),
          lineStyle: { type: 'dashed', width: 2, color: lineColor },
          itemStyle: { color: lineColor },
        })
      })
  }

  const hasMultipleSeries = series.length > 1
  const option = {
    aria: { enabled: true },
    // Show the legend on the top to fix the issue from echart 6 that make the legend and date range overlap
    legend: hasMultipleSeries
      ? {
          top: 10,
          left: 'center',
          itemGap: 20,
        }
      : {},
    grid: {
      top: hasMultipleSeries ? 50 : 20,
      bottom: emptyData(rawData) ? 20 : 80,
      left: 60,
      right: 20,
    },
    dataZoom: emptyData(rawData) ? [] : dataZoom,
    tooltip: {
      padding: 5,
      borderWidth: 1,
      textStyle: { fontSize: 12 },
      trigger: 'axis',
      valueFormatter: (value) => formatValueWithUnit(value, unit),
      axisPointer: {
        type: 'line',
        lineStyle: { type: 'dotted', width: 2 },
        label: {
          formatter: ({ value }) => formatTimeWithWeekDay(value),
        },
      },
    },
    xAxis: {
      data: x.values,
      type: 'category',
      axisLabel: {
        formatter: (value) => (dateFormat === 'hourly' ? formatHourAndMinute(value) : xAxisDailyDateFormatter(value)),
      },
      silent: false,
      splitLine: { show: false },
      splitArea: { show: false },
    },
    yAxis: {
      type: 'log',
      axisLabel: {
        formatter: (value) => formatValueWithUnit(value, unit),
      },
      splitArea: { show: false },
      max: maxYAxisValue,
    },
    series,
  }

  return option
}
